import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerText: {
      color: '#33444E',
    },
    formInput: {
      margin: theme.spacing(3),
    },
    surface: {
      background: '#EDF0F2',
      padding: theme.spacing(2),
    },
    outerGrid: {
      margin: 0,
      marginBottom: theme.spacing(2),
    },
    tabsHolder: {
      flexGrow: 1,
      backgroundColor: 'red',
      display: 'flex',
      // height: 224,
    },
    tabs: {},
    addButton: {
      color: '#3463FD',
    },
  })
);
